<template lang="html">
  <div class="adopt">
    <v-row justify=center>
      <v-col cols="12" md="8">
        <nav class="componentSelectNav">
          <router-link
            tag="span"
            class="navitem"
            :to="{name:'orokbefogadas', query:{selectedComp: 'AdoptionInfo'}}"
            :class="selectedComp=='AdoptionInfo' ? 'navitem-active' : ''"
            >Az örökbefogadásról</router-link>
          <span class="divider">|</span>
          <router-link
            tag="span"
            class="navitem"
            :to="{name:'orokbefogadas', query:{selectedComp: 'ToBeAdopted'}}"
            :class="selectedComp=='ToBeAdopted' ? 'navitem-active' : ''"
            >Örökbefogadásra várnak</router-link>
          <span class="divider">|</span>
          <router-link
            tag="span"
            class="navitem"
            :to="{name:'orokbefogadas', query:{selectedComp: 'AlreadyAdopted'}}"
            :class="selectedComp=='AlreadyAdopted' ? 'navitem-active' : ''"
            >Már gazdisodtak</router-link>
        </nav>
      </v-col>
    </v-row>

    <component :is="selectedComp" />

  </div>
</template>

<script>
import ToBeAdopted from '@/components/Orokbeadas/ToBeAdopted.vue'
import AlreadyAdopted from '@/components/Orokbeadas/AlreadyAdopted.vue'
import AdoptionInfo from '@/components/Orokbeadas/AdoptionInfo.vue'

export default {
  data(){
    return{
      selectedComp: 'AdoptionInfo',
    }
  },
  components:{
    ToBeAdopted,
    AlreadyAdopted,
    AdoptionInfo,
  },
  mounted(){
    this.selectedComp = this.$route.query.selectedComp ?  this.$route.query.selectedComp : 'ToBeAdopted';
  },
  watch:{
    '$route'(to,from){
      this.selectedComp = this.$route.query.selectedComp ?  this.$route.query.selectedComp : 'ToBeAdopted';
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
